import { useEffect, useRef } from 'react';

const useHandleSelectedItemsChange = <T extends { id: string; isSelected: boolean }>(
  items: T[],
  handleOnSelectionChange: (items: T[]) => void
) => {
  const previousItemsRef = useRef<T[]>(items);

  useEffect(() => {
    const previousItems = previousItemsRef.current;

    const hasSelectionChanged = items.some((item, index) => {
      return item.isSelected !== (previousItems[index]?.isSelected ?? false);
    });

    if (hasSelectionChanged) {
      handleOnSelectionChange(items);
    }

    // Update the ref with the current items after checking
    previousItemsRef.current = items;
  }, [items, handleOnSelectionChange]);
};

export default useHandleSelectedItemsChange;
